import { EpgDetailDataSource } from './EpgDetailDataSource';
import { EpgUtil } from '../../utility/EpgUtil';
import { EpgApi } from '../../../api/EpgApi';
import { AssetType } from '../../../api/models/Shared.types';
import { StaticPageUrls } from '../../../api/analytics/ClientEvents';
import { DetailTranslationKeys, GuideTranslationKeys } from '../../../api/models/TranslationKeys';
import { ActionButton } from '../../../pages/detail/actionRowButtons/ActionButton';
import { EpgCancelRecordingAction, EpgDeleteRecordingAction } from '../actions/epgRecordingActions';
import { Backend } from '../../../api/Backend';
import { IActionButtonDefinition } from '../detail.types';
import { ISeriesDetail } from '../../../api/models/AndromeTV.types';

export class RecordingDetailDataSource extends EpgDetailDataSource {
  constructor(backend: Backend) {
    super(backend);
    this.pageType = AssetType.RECORDING;
  }

  override logPageView() {
    this.backend.logService.trackPageView(StaticPageUrls.recordingDetail);
  }

  override getCancelRecordButton(): IActionButtonDefinition | undefined {
    if (!this.recording || !this.program) return undefined;
    return {
      type: ActionButton,
      actionHandler: new EpgCancelRecordingAction(this.backend, this.recording, this.program, true),
      label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel),
    };
  }

  override getDeleteRecordButton(): IActionButtonDefinition | undefined {
    if (!this.recording || !this.program) return undefined;
    return {
      type: ActionButton,
      actionHandler: new EpgDeleteRecordingAction(this.backend, this.program.title, this.recording.identifier, true),
      label: this.backend.translations.forKey(DetailTranslationKeys.detail_recording_delete),
    };
  }

  override load(id: string) {
    return this.initChannels().then(() => {
      return this.backend.cachedRecordingsApi.recording(this.backend, id).then(recording => {
        if (recording === undefined) {
          // No recording found
          throw this.backend.translations.forKey(GuideTranslationKeys.guide_no_information);
        }
        this.recording = recording;
        this.channel = this.channelsList?.find(ch => ch.channelId === recording.channel);
        const fromuntil = EpgUtil.epgFromUntil(this.backend);
        return EpgApi.program(
          this.backend,
          recording.program,
          fromuntil.from,
          fromuntil.until,
          this.backend.deviceProfile?.profile.catalog
        ).then(result => {
          this.program = result.program;
          if (result.series?.title) {
            this.series = result.series as ISeriesDetail;
          }
          this.season = result.season;

          if (result.schedules) {
            this.schedule = result.schedules.find(schedule => schedule.id === this.recording?.schedule);
          }
          if (!this.schedule && this.recording?.schedule) {
            return EpgApi.schedule(this.backend, this.recording.schedule)
              .then(info => {
                if (info.schedule) {
                  this.schedule = info.schedule;
                }
                return super.load(id);
              })
              .catch(() => {
                return super.load(id);
              });
          } else {
            return super.load(id);
          }
        });
      });
    });
  }
}
